
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "feedback-public-submission-ui",
  currentProjectVersion: "static-1.31014",
  depVersions: {
  "feedback-public-submission-ui": "static-1.31014",
  "emoji-mart": "static-3.7",
  "feedback-schema": "static-1.55600",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8512",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11961",
  "I18n": "static-7.1707",
  "quartz": "static-1.7657",
  "quartz-config": "static-1.1435",
  "quartz-core": "static-1.6876",
  "react-dlb": "static-1.93",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.84",
  "reselect": "static-3.16",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1096",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55587",
  "feedback-utils": "static-1.55591",
  "forms-embed-utils-lib": "static-1.4934",
  "forms-utils-lib": "static-1.13334",
  "foundations-assets": "static-1.5359",
  "foundations-components": "static-1.8747",
  "foundations-theming": "static-1.4961",
  "hub-http": "static-1.6680",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12268",
  "icons": "static-2.702",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4230",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17208",
  "react-select-plus": "static-1.118",
  "react-utils": "static-2.5656",
  "react-virtualized": "static-2.112",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.518",
  "tinymce-plugins": "static-1.58508",
  "transmute": "static-2.97",
  "ui-images": "static-2.1276",
  "UIComponents": "static-3.8907",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3934",
  "quartz-webpack": "static-1.3881",
  "foundations-theming-specialty": "static-1.2677",
  "property-description-translator": "static-1.4293",
  "HeadJS": "static-2.821",
  "framer-motion": "static-1.84",
  "hs-test-utils-bend-plugin": "static-1.3623",
  "msw": "static-1.102",
  "msw-config": "static-1.28",
  "testing-library": "static-1.164",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4781",
  "jasmine-runner": "static-1.6925",
  "opentelemetry-fe-types": "static-1.265",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.906",
  "hubspotter-http": "static-1.4975",
  "mobile-manifest-mixins": "static-1.605",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.640",
  "quartz-auth": "static-1.1332",
  "quartz-head": "static-1.1322",
  "quartz-i18n": "static-1.1332",
  "quartz-routing": "static-1.1087",
  "quartz-test": "static-1.1332",
  "quartz-tracking": "static-1.1036",
  "trellis-components": "static-1.3100",
  "ui-fonts": "static-1.1223",
  "usage-tracker-container": "static-1.7787",
  "usage-tracker-core": "static-1.7647",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.362",
  "conversations-skeleton-state": "static-1.7608",
  "reference-resolvers": "static-1.8656",
  "sanitize-text": "static-1.8631",
  "PatternValidationJS": "static-1.3358",
  "ReduxMessenger": "static-2.10844",
  "outpost": "static-1.4601",
  "rpc-client-utils": "static-1.5143",
  "sanitize": "static-1.4948",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.5016",
  "floating-ui": "static-1.68",
  "hs-story-utils": "static-1.9897",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.102",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3081",
  "bend-plugin-foundations-theming": "static-1.3444",
  "foundations-theming-base": "static-1.3946",
  "stylex": "static-1.46",
  "hs-locale-management": "static-1.400",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.174",
  "web-vitals": "static-1.19",
  "ai-components-ui-library": "static-1.10015",
  "atom": "static-1.5546",
  "codemirror": "static-5.106",
  "content-assistance-lib": "static-1.8420",
  "ContentUtils": "static-1.69466",
  "data-token-picker": "static-1.17132",
  "file-manager-components": "static-1.24839",
  "FileManagerCore": "static-1.40338",
  "FileManagerLib": "static-1.40479",
  "frontend-preferences-client": "static-1.8394",
  "hub-http-contrib": "static-1.3505",
  "interframe": "static-3.5214",
  "layout-dnd-components": "static-1.13226",
  "layout-dnd-utils": "static-1.12201",
  "property-translator": "static-1.5853",
  "react-codemirror": "static-1.11115",
  "react-colorpicker": "static-2.10683",
  "reference-resolvers-lite": "static-1.8584",
  "rich-text-lib": "static-1.20551",
  "tinymce-data": "static-1.41479",
  "tinymce-themes": "static-1.57364",
  "ui-addon-emoji-picker": "static-1.10337",
  "ui-addon-sales-email": "static-1.5675",
  "ui-brand-identity-lib": "static-1.16942",
  "bender-build-tools": "static-1.3578",
  "opentelemetry-web": "static-1.22",
  "hub-http-shared-msw-handlers": "static-1.10899",
  "hubspotter-http-shared-msw-handlers": "static-1.10897",
  "usage-tracker-session-replay": "static-1.5483",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.15",
  "trellis-theming": "static-1.1474",
  "tanstack-virtual": "static-1.43",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.553",
  "chirp-fetch": "static-1.2378",
  "stylex-utils": "static-1.174",
  "chatspot-core": "static-1.23875",
  "copilot-toolkit": "static-1.12144",
  "customer-data-objects-ui-components": "static-1.13509",
  "data-fetching-client": "static-1.10114",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5233",
  "ui-addon-video-player": "static-1.9097",
  "ui-coaching-tips": "static-1.29582",
  "usage-tracker": "static-1.7797",
  "cms-field-types": "static-1.5284",
  "content-icons-ui": "static-1.2455",
  "integrations-lib": "static-1.17428",
  "customer-data-objects": "static-1.8176",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.2168",
  "apollo-link-hub-http": "static-2.5061",
  "apollo-stack-hubspot": "static-3.99",
  "graphql": "static-1.93",
  "immer": "static-1.105",
  "immerable": "static-1.4615",
  "poll-commands": "static-1.3951",
  "ui-addon-iframeable": "static-1.9548",
  "video-components-external": "static-1.12427",
  "video-data-lib": "static-1.36085",
  "audio-components": "static-1.6568",
  "breeze-artifacts-sdk": "static-1.935",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30059",
  "FileManagerImages": "static-1.37990",
  "foundations-components-legacy": "static-1.1772",
  "html-to-image": "static-1.65",
  "redux-toolkit": "static-1.82",
  "salesImages": "static-1.731",
  "ui-universal-auth": "static-1.9740",
  "urlinator": "static-1.4988",
  "video-components": "static-1.14429",
  "video-embed": "static-1.36919",
  "ts-schema": "static-1.4392",
  "ContentData": "static-1.69541",
  "layout-data-lib": "static-1.10526",
  "react-dnd-compat": "static-1.5083",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.2021",
  "external-options-client-types": "static-1.4439",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6066",
  "hs-resources": "static-1.667",
  "inbound-db-properties-service-client": "static-1.4151",
  "NamespacedHubStyle": "static-2.9366",
  "growth-onboarding-confetti": "static-1.3532",
  "SharedI18nStrings": "static-1.187",
  "ui-addon-i18n": "static-1.11619",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5906",
  "magpie-types": "static-1.5366",
  "simple-logging-lib": "static-1.3524",
  "avatar-components": "static-1.2961",
  "customer-data-ui-utilities": "static-1.10307",
  "growth-onboarding-feedback-components": "static-1.7056",
  "flux-actions": "static-1.380",
  "hubspot-apollo-client": "static-1.5354",
  "integrations-error-boundary-lib": "static-1.14843",
  "integrations-tracking-lib": "static-1.6093",
  "laboratory-lib": "static-3.7620",
  "native-integrations-shared-strings": "static-1.8237",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10752",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1146",
  "breeze-engine-core": "static-1.1446",
  "highlight.js": "static-1.90",
  "pulse": "static-1.1119",
  "navigation-messaging": "static-1.8491",
  "content-media-composition-data-lib": "static-1.13589",
  "content-media-compositions": "static-2.17596",
  "idb-keyval": "static-1.55",
  "media-bridge-lib": "static-1.19639",
  "nudge-client-utils": "static-1.3416",
  "custom-vendor-connection-lib": "static-1.304",
  "unified-auth-core-lib": "static-1.1536",
  "social-insights-client-types": "static-1.22927",
  "advanced-menus-core": "static-1.15813",
  "advanced-menus-lib": "static-1.12567",
  "ExportDialog": "static-6.10848",
  "ui-memberships-settings-lib": "static-1.35188",
  "conditional-properties-service-client": "static-1.4113",
  "crm-pipelines-api-client-types": "static-1.4443",
  "event-emitter": "static-1.1435",
  "fdsr-migration-layer": "static-1.484",
  "framework-builder-read-service-client": "static-1.4334",
  "inbound-db-meta-service-client": "static-1.3774",
  "multi-currency-client-types": "static-1.4007",
  "foundations-components-test-utils": "static-1.6230",
  "reactive-lib": "static-1.1192",
  "trellis-migration-context": "static-1.53",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.813",
  "universal-page-editor-lib": "static-1.3483",
  "bend-plugin-pulse": "static-1.622",
  "fast-json-patch": "static-1.74",
  "nav-meta": "static-1.30801",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3173",
  "nudge-renderer-utils": "static-1.3492",
  "onboarding-tours": "static-1.17401",
  "whisper-core-api": "static-1.7633",
  "fsm": "static-1.4231",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15812",
  "simple-menus-lib": "static-1.17329",
  "settings-ui-lib": "static-1.13000",
  "persist-promise": "static-1.4178",
  "crm-record-cards-service-types": "static-1.3871",
  "framework-data-schema-resolvers": "static-1.7365",
  "location-customization-utils-lib": "static-1.10416",
  "getting-started-shared-tasks": "static-1.19559",
  "growth-data-modal": "static-1.6131",
  "growth-onboarding-next-action-utils": "static-1.2980",
  "navigation-components": "static-1.19164",
  "nest": "static-1.707",
  "onboarding-tours-client": "static-1.5616",
  "onboarding-tours-utils": "static-1.1468",
  "ui-shepherd-tracker": "static-1.8133",
  "user-context": "static-1.5527",
  "react-flip-move": "static-1.83",
  "framework-data-schema-quick-fetch": "static-1.7270",
  "onboarding-data-sync-lib": "static-1.2837",
  "growth-onboarding-next-action-components": "static-1.3008",
  "user-context-client": "static-1.4983",
  "getting-started-shared-tasks-store": "static-1.18677",
  "InboxConnectUtils": "static-4.15841",
  "meetings-connect-utils-lib": "static-1.8092",
  "onboarding-scopes": "static-1.6926"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.31014",
  "emoji-mart": "/emoji-mart/static-3.7",
  "feedback-schema": "/feedback-schema/static-1.55600",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8512",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11961",
  "I18n": "/I18n/static-7.1707",
  "quartz": "/quartz/static-1.7657",
  "quartz-config": "/quartz-config/static-1.1435",
  "quartz-core": "/quartz-core/static-1.6876",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.84",
  "reselect": "/reselect/static-3.16",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1096",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55587",
  "feedback-utils": "/feedback-utils/static-1.55591",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4934",
  "forms-utils-lib": "/forms-utils-lib/static-1.13334",
  "foundations-assets": "/foundations-assets/static-1.5359",
  "foundations-components": "/foundations-components/static-1.8747",
  "foundations-theming": "/foundations-theming/static-1.4961",
  "hub-http": "/hub-http/static-1.6680",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12268",
  "icons": "/icons/static-2.702",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4230",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17208",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-utils": "/react-utils/static-2.5656",
  "react-virtualized": "/react-virtualized/static-2.112",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "tinymce-plugins": "/tinymce-plugins/static-1.58508",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1276",
  "UIComponents": "/UIComponents/static-3.8907",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3934",
  "quartz-webpack": "/quartz-webpack/static-1.3881",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2677",
  "property-description-translator": "/property-description-translator/static-1.4293",
  "HeadJS": "/HeadJS/static-2.821",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3623",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.28",
  "testing-library": "/testing-library/static-1.164",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4781",
  "jasmine-runner": "/jasmine-runner/static-1.6925",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.265",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.906",
  "hubspotter-http": "/hubspotter-http/static-1.4975",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.605",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.640",
  "quartz-auth": "/quartz-auth/static-1.1332",
  "quartz-head": "/quartz-head/static-1.1322",
  "quartz-i18n": "/quartz-i18n/static-1.1332",
  "quartz-routing": "/quartz-routing/static-1.1087",
  "quartz-test": "/quartz-test/static-1.1332",
  "quartz-tracking": "/quartz-tracking/static-1.1036",
  "trellis-components": "/trellis-components/static-1.3100",
  "ui-fonts": "/ui-fonts/static-1.1223",
  "usage-tracker-container": "/usage-tracker-container/static-1.7787",
  "usage-tracker-core": "/usage-tracker-core/static-1.7647",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.362",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "reference-resolvers": "/reference-resolvers/static-1.8656",
  "sanitize-text": "/sanitize-text/static-1.8631",
  "PatternValidationJS": "/PatternValidationJS/static-1.3358",
  "ReduxMessenger": "/ReduxMessenger/static-2.10844",
  "outpost": "/outpost/static-1.4601",
  "rpc-client-utils": "/rpc-client-utils/static-1.5143",
  "sanitize": "/sanitize/static-1.4948",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5016",
  "floating-ui": "/floating-ui/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9897",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.102",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3081",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3444",
  "foundations-theming-base": "/foundations-theming-base/static-1.3946",
  "stylex": "/stylex/static-1.46",
  "hs-locale-management": "/hs-locale-management/static-1.400",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.174",
  "web-vitals": "/web-vitals/static-1.19",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10015",
  "atom": "/atom/static-1.5546",
  "codemirror": "/codemirror/static-5.106",
  "content-assistance-lib": "/content-assistance-lib/static-1.8420",
  "ContentUtils": "/ContentUtils/static-1.69466",
  "data-token-picker": "/data-token-picker/static-1.17132",
  "file-manager-components": "/file-manager-components/static-1.24839",
  "FileManagerCore": "/FileManagerCore/static-1.40338",
  "FileManagerLib": "/FileManagerLib/static-1.40479",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8394",
  "hub-http-contrib": "/hub-http-contrib/static-1.3505",
  "interframe": "/interframe/static-3.5214",
  "layout-dnd-components": "/layout-dnd-components/static-1.13226",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12201",
  "property-translator": "/property-translator/static-1.5853",
  "react-codemirror": "/react-codemirror/static-1.11115",
  "react-colorpicker": "/react-colorpicker/static-2.10683",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8584",
  "rich-text-lib": "/rich-text-lib/static-1.20551",
  "tinymce-data": "/tinymce-data/static-1.41479",
  "tinymce-themes": "/tinymce-themes/static-1.57364",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10337",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5675",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16942",
  "bender-build-tools": "/bender-build-tools/static-1.3578",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10899",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10897",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5483",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.15",
  "trellis-theming": "/trellis-theming/static-1.1474",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.553",
  "chirp-fetch": "/chirp-fetch/static-1.2378",
  "stylex-utils": "/stylex-utils/static-1.174",
  "chatspot-core": "/chatspot-core/static-1.23875",
  "copilot-toolkit": "/copilot-toolkit/static-1.12144",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13509",
  "data-fetching-client": "/data-fetching-client/static-1.10114",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5233",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9097",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29582",
  "usage-tracker": "/usage-tracker/static-1.7797",
  "cms-field-types": "/cms-field-types/static-1.5284",
  "content-icons-ui": "/content-icons-ui/static-1.2455",
  "integrations-lib": "/integrations-lib/static-1.17428",
  "customer-data-objects": "/customer-data-objects/static-1.8176",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2168",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5061",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.99",
  "graphql": "/graphql/static-1.93",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4615",
  "poll-commands": "/poll-commands/static-1.3951",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9548",
  "video-components-external": "/video-components-external/static-1.12427",
  "video-data-lib": "/video-data-lib/static-1.36085",
  "audio-components": "/audio-components/static-1.6568",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.935",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30059",
  "FileManagerImages": "/FileManagerImages/static-1.37990",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1772",
  "html-to-image": "/html-to-image/static-1.65",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "salesImages": "/salesImages/static-1.731",
  "ui-universal-auth": "/ui-universal-auth/static-1.9740",
  "urlinator": "/urlinator/static-1.4988",
  "video-components": "/video-components/static-1.14429",
  "video-embed": "/video-embed/static-1.36919",
  "ts-schema": "/ts-schema/static-1.4392",
  "ContentData": "/ContentData/static-1.69541",
  "layout-data-lib": "/layout-data-lib/static-1.10526",
  "react-dnd-compat": "/react-dnd-compat/static-1.5083",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.2021",
  "external-options-client-types": "/external-options-client-types/static-1.4439",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6066",
  "hs-resources": "/hs-resources/static-1.667",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4151",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9366",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3532",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11619",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5906",
  "magpie-types": "/magpie-types/static-1.5366",
  "simple-logging-lib": "/simple-logging-lib/static-1.3524",
  "avatar-components": "/avatar-components/static-1.2961",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10307",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7056",
  "flux-actions": "/flux-actions/static-1.380",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5354",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14843",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6093",
  "laboratory-lib": "/laboratory-lib/static-3.7620",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8237",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10752",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1146",
  "breeze-engine-core": "/breeze-engine-core/static-1.1446",
  "highlight.js": "/highlight.js/static-1.90",
  "pulse": "/pulse/static-1.1119",
  "navigation-messaging": "/navigation-messaging/static-1.8491",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13589",
  "content-media-compositions": "/content-media-compositions/static-2.17596",
  "idb-keyval": "/idb-keyval/static-1.55",
  "media-bridge-lib": "/media-bridge-lib/static-1.19639",
  "nudge-client-utils": "/nudge-client-utils/static-1.3416",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.304",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1536",
  "social-insights-client-types": "/social-insights-client-types/static-1.22927",
  "advanced-menus-core": "/advanced-menus-core/static-1.15813",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12567",
  "ExportDialog": "/ExportDialog/static-6.10848",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35188",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4113",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4443",
  "event-emitter": "/event-emitter/static-1.1435",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.484",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4334",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3774",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4007",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6230",
  "reactive-lib": "/reactive-lib/static-1.1192",
  "trellis-migration-context": "/trellis-migration-context/static-1.53",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.813",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3483",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.622",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "nav-meta": "/nav-meta/static-1.30801",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3173",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3492",
  "onboarding-tours": "/onboarding-tours/static-1.17401",
  "whisper-core-api": "/whisper-core-api/static-1.7633",
  "fsm": "/fsm/static-1.4231",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15812",
  "simple-menus-lib": "/simple-menus-lib/static-1.17329",
  "settings-ui-lib": "/settings-ui-lib/static-1.13000",
  "persist-promise": "/persist-promise/static-1.4178",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7365",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10416",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19559",
  "growth-data-modal": "/growth-data-modal/static-1.6131",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2980",
  "navigation-components": "/navigation-components/static-1.19164",
  "nest": "/nest/static-1.707",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5616",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1468",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8133",
  "user-context": "/user-context/static-1.5527",
  "react-flip-move": "/react-flip-move/static-1.83",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7270",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2837",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3008",
  "user-context-client": "/user-context-client/static-1.4983",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18677",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15841",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8092",
  "onboarding-scopes": "/onboarding-scopes/static-1.6926"
}
};
